import { render, staticRenderFns } from "./TenantsHome.vue?vue&type=template&id=95c745b6&"
import script from "./TenantsHome.vue?vue&type=script&lang=ts&"
export * from "./TenantsHome.vue?vue&type=script&lang=ts&"
import style0 from "./TenantsHome.vue?vue&type=style&index=0&id=95c745b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports